import { clearModalHack } from '@/services/utils';
import axios from 'axios';
import { getSupportArticleUrl } from '@/services/supportUrlService';
(function () {
  angular.module('leanlaw').directive('llInvoiceProcessList', InvoiceListDirective);
  InvoiceListDirective.$inject = ['$q', '$rootScope', '$http', '$window', 'download', 'userService', 'leanLawApi', 'leanLawAuth', 'invoiceFilterService', 'billingFilterService', 'matterFilterService', 'filterService', '$timeout', '$filter', 'ModalService', 'exportJson'];
  function InvoiceListDirective($q, $rootScope, $http, $window, download, userService, leanLawApi, leanLawAuth, invoiceFilterService, billingFilterService, matterFilterService, filterService, $timeout, $filter, ModalService, exportJson) {
    return {
      restrict: 'EA',
      template: require('./views/invoiceList.html'),
      transclude: true,
      scope: {
        invoiceState: '@',
        options: '=',
        callback: '=',
        stateName: '=',
        subHeader: '=',
        me: '='
      },
      link: InvoiceListLink,
      controller: ['$q', '$rootScope', '$scope', '$http', '$state', 'alerts', 'reviewService', 'singleRequest', 'accountingService', 'processService', 'tracking', 'company', InvoiceListController]
    };
    function InvoiceListLink(scope, element, attr) {
      scope.textNone = element.find('.ll-text-none').text();
      scope.textSubheader = element.find('.ll-text-subheader').text();
    }
    function InvoiceListController($q, $rootScope, $scope, $http, $state, alerts, reviewService, singleRequest, accountingService, processService, tracking, company) {
      $scope.filter = invoiceFilterService.state;
      // Template references `state.cm` and `state.filter` (ng-model bindings shared
      // with BillingCtrl) and needs `state` to resolve on this isolate scope.
      // Careful: llInvoiceReviewFilter declares no scope of its own, so when it links
      // it reassigns `state` here to billingFilterService.state — that, not this
      // alias, is where the template's writes land, and it is why filterUpdated()
      // reads the scope and client/matter back off `dateFilter`.
      $scope.state = invoiceFilterService.state;
      $scope.dateFilter = billingFilterService.state;
      $scope.showBalance = !($scope.invoiceState === 'draft' || $scope.invoiceState === 'approved' || $scope.invoiceState === 'review');

      // Only show secondary split matters on the QuickBooks tab
      // (preserves prior ll-client-matter-picker behavior)
      if ($scope.filter.cmQuery) {
        $scope.filter.cmQuery.showSecondarySplitMatter = $scope.invoiceState === 'quickbooks';
      }
      $scope.select = selectInvoice;
      $scope.print = printInvoice;
      $scope.open = openInvoice;
      $scope.processInvoice = processInvoice;
      $scope.printInvoices = printInvoices;
      $scope.downloadInvoices = downloadInvoices;
      $scope.getSelectedInvoices = getSelectedInvoices;
      $scope.showAllocation = showAllocation;
      $scope.openCustomizationEmailModal = openCustomizationEmailModal;
      $scope.goToTrackSentEmail = goToTrackSentEmail;
      $scope.viewInvoiceSummary = viewInvoiceSummary;
      $scope.exportExcel = exportExcel;
      $scope.copyPaymentLink = copyPaymentLink;
      $scope.getPaymentLink = getPaymentLink;
      $scope.domain = `${leanLawAuth.domain}/v1`;
      $scope.emailTrackingUrl = getSupportArticleUrl('emailTracking');
      $scope.gravityEnabled = gravityEnabled;
      $scope.codesExpenseAttachments = false;
      $rootScope.processCustomizedEmail = processCustomizedEmail;
      $rootScope.sendGroupInvoiceEmail = sendGroupInvoiceEmail;
      $rootScope.processGroupInvoicePdf = processGroupInvoicePdf;
      $rootScope.selectNextInvoice = selectInvoice;
      $rootScope.reload = reload;
      $scope.downloadServicesAndExpenses = downloadServicesAndExpenses;
      $scope.handleBulkInvoiceDateChange = handleBulkInvoiceDateChange;
      $scope.callback.reload = reload;
      $scope.sort = ['invoiceDate', 'reference'];
      $scope.reverse = [true, false, false];
      $scope.timeOffset = new Date().getTimezoneOffset();
      $scope.checkAll = function () {
        $scope.invoices.forEach(i => i.selected = false);
        if ($scope.filtered) {
          $scope.filtered.forEach(i => i.selected = $scope.all);
        }
        $scope.updateInvoiceCheck();
      };
      $scope.currPage = 1;
      $scope.pageSize = 30;
      $scope.pageSizePrev = $scope.pageSize;
      $scope.lastPage;
      $scope.calcLastPage = calcLastPage;
      function calcLastPage() {
        $scope.lastPage = Math.ceil($scope.numClients / $scope.pageSize);
      }
      $scope.invoiceDeliveryOptions = [{
        id: 'emailFailed',
        label: 'Email failed'
      }, {
        id: 'emailing',
        label: 'Sending'
      }, {
        id: 'toEmail',
        label: 'Ready to email'
      }, {
        id: 'toPrint',
        label: 'Ready to print'
      }, {
        id: 'emailed',
        label: 'Emailed'
      }, {
        id: 'printed',
        label: 'Printed'
      }];
      $scope.paidOptions = [{
        id: 'open',
        label: 'Not Paid',
        state: 'open'
      }, {
        id: 'overdue',
        label: 'Overdue',
        state: 'open'
      }, {
        id: 'paid',
        label: 'Paid',
        state: 'closed'
      }];
      $scope.trustOptions = [{
        id: 'trust',
        label: 'With Trust'
      }, {
        id: 'notrust',
        label: 'Without Trust'
      }];
      $scope.evergreenOptions = [{
        id: 'evergreen',
        label: 'With Evergreen'
      }, {
        id: 'replenish',
        label: 'With Pending'
      }];
      $scope.ledesOptions = [{
        id: 'ledes',
        label: 'With LEDES'
      }, {
        id: 'noledes',
        label: 'Without LEDES'
      }];
      $scope.bulkDate = new Date();
      $scope.showDatePicker = false;
      activate();

      ///////////////////

      let _loadedState;
      let _loadedInvoiceState;
      let _users;
      function activate() {
        reviewService.ready.then(() => {
          $scope.stage = _.find(reviewService.stages, s => s.id === $scope.invoiceState);
          _loadedInvoiceState = $scope.stage.request;
          userService.list({
            status: 'all'
          }).then(users => {
            _users = users;
          });

          // Nothing is fetched until every filter that shapes the request is in
          // place: the paid default set below, and the responsible-attorney scope
          // that llMatterFilter copies out of matterFilterService. Loading first and
          // letting those land afterwards sent three requests, and the first of them
          // asked for every open and closed invoice with no scope -- a query that was
          // always superseded before it returned, and ran for minutes on large firms.
          // A filter service that fails to load still gets the list on screen.
          $q.all([userService.me(), $q.when(matterFilterService.loaded).catch(() => null)]).then(([me]) => {
            $scope.me = me;
            $scope.emailTrackingUrl = getSupportArticleUrl('emailTracking');
            if (['draft', 'approved', 'review'].includes($scope.invoiceState)) {
              $scope.showDatePicker = true;
            }
            $scope.codesExpenseAttachments = me.company?.settings?.codes?.expenseAttachments;
            $scope.traceData = {
              companyName: me.company.name,
              companyId: me.company.id,
              userEmail: me.email
            };
            $scope.showStatus = $scope.invoiceState !== 'draft' && $scope.invoiceState !== 'approved' && $scope.invoiceState !== 'review';
            if ($scope.invoiceState === 'quickbooks') {
              $scope.showDue = true;
              $scope.showEmail = true;
              $scope.showFilters = true;
              $scope.filter.paid = $scope.paidOptions.find(o => o.id === 'open');
              if (me.company.settings.trustEnabled) {
                $scope.showTrust = true;
                $scope.showEvergreen = !!me.company.settings.trust.evergreenService;
                loadTrust();
              }
            } else {
              $scope.filter.paid = null;
            }
            seedScopeFilter();
            $scope.$watch('filter', () => filterUpdated(), true);
            $scope.$watch('dateFilter', () => filterUpdated(), true);
            filterUpdated();
          });
          $scope.$watch('options', options => {
            $scope.invoiceOptions = [];
            if (!options) return;

            // flatten out the options for the invoice menu
            options.forEach(o => {
              if (o.actions) {
                $scope.invoiceOptions.push(o);
              }
              if (o.dropdown) {
                $scope.invoiceOptions = $scope.invoiceOptions.concat(o.dropdown);
              }
            });
          });
        });
      }

      // llMatterFilter owns this filter, but only pushes it into billingFilterService
      // after three awaits of its own -- so the first request would go out unscoped
      // and be thrown away. Deriving the same values here lets it go out scoped; the
      // directive's later write then builds an identical request, which
      // isIdenticalToPreviousRequest drops.
      function seedScopeFilter() {
        const matterFilter = matterFilterService.state;
        $scope.dateFilter.filter = angular.extend({}, $scope.dateFilter.filter, {
          scope: filterService.scopeFromFilter(matterFilter),
          scopeAccount: matterFilter.scopeAccount || null,
          matterTag: matterFilter.matterTag || null
        });
      }
      let _trust;
      let _trustBalances;
      let _previousRequest;
      function isIdenticalToPreviousRequest(request) {
        if (_previousRequest) {
          if (compareVisibleProps(request, _previousRequest)) {
            return true;
          }
          function compareVisibleProps(obj1, obj2) {
            const getSortedEntries = obj => JSON.stringify(Object.entries(obj).sort());
            return getSortedEntries(obj1) === getSortedEntries(obj2);
          }
        }
        _previousRequest = angular.copy(request);
        return false;
      }
      function loadTrust() {
        if (!$scope.showTrust) return;
        $scope.loadingTrust = true;
        singleRequest.apiCall('trust').listAccountingTrust({
          scope: 'all'
        }).then(list => {
          if (!list) return;
          _trust = list;
          _trustBalances = {};
          _trust.accounts.forEach(account => {
            account.clients.forEach(client => {
              _trustBalances[client.client.id] = client.balance;
              client.matters.forEach(matter => {
                _trustBalances[matter.matter.id] = matter.balance;
              });
            });
          });
          applyTrustBalances();
          $scope.loadingTrust = false;
        }).catch(err => {
          alerts.error(err);
          $scope.loadingTrust = false;
        });
      }
      function reloadTrust() {
        _trustBalances = null;
        _trust = null;
        loadTrust();
      }
      function filterUpdated(invoicesWithStatus) {
        let newInvoiceState = _loadedInvoiceState;
        if ($scope.invoiceState === 'quickbooks') {
          // if we are on the quickbooks tab we lazy load paid invoices because there might
          // be a lot of them and the default filter hides them.
          // TODO additional optimization: if we have closed 'open,closed' ie all invoices and
          // the filter changes to only 'open' or 'closed' (and not other filter options change)
          // then no need to reload again
          newInvoiceState = $scope.filter.paid ? $scope.filter.paid.state : 'open,closed';
        }
        _loadedState = angular.copy(invoiceFilterService.state);
        _loadedInvoiceState = newInvoiceState;
        const request = invoiceFilterService.filterQuery(true);
        const {
          startDate,
          endDate
        } = $scope.dateFilter.range;
        const {
          client,
          matter
        } = $scope.dateFilter.cm || {};
        const {
          scope,
          scopeAccount,
          matterTag
        } = $scope.dateFilter.filter || {};
        request.startDate = startDate ? startDate.toNetworkDate() : null;
        request.endDate = endDate ? endDate.toNetworkDate() : null;
        request.clientId = client ? client.id : null;
        request.matterId = matter ? matter.id : null;
        request.scope = scope ? scope : null;
        request.scopeAccount = scopeAccount ? scopeAccount.id : null;
        request.matterTag = matterTag ? matterTag : null;
        request.state = _loadedInvoiceState;
        request.status = $scope.stage.requestStatus;
        if ($scope.filter?.deliveryStatuses?.length) {
          request.deliveryStatuses = $scope.filter.deliveryStatuses.map(obj => obj.id);
        }
        request.check = true;
        if (isIdenticalToPreviousRequest(request)) {
          return;
        }
        $scope.loading = true;
        singleRequest.apiCall('invoices').listInvoices(request).then(list => {
          if (!list) return; // happens if we were canceled
          $scope.invoices = list.invoices;
          $scope.invoices.forEach(i => {
            i.invoiceState = reviewService.invoiceLabel(i);
            i.invoiceColor = reviewService.invoiceColor(i);
            if (i.state.overdue) {
              i.duedays = Math.round((new Date() - new Date(i.due)) / (60 * 60 * 24 * 1000));
            }
            if (invoicesWithStatus) {
              // if invoicesWithStatus is passed in, it is because we are reloading invoices
              // after processing them. So we merge in the "process" property which contains
              // done/error information
              const withStatus = invoicesWithStatus.find(ii => ii.id === i.id);
              if (withStatus) {
                i.process = withStatus.process;
              }
            }
          });
          $scope.numClients = list.invoices.length;
          $scope.loading = false;
          $scope.checkAll();
          applyTrustBalances();
        }).catch(err => {
          alerts.error(err);
        });
      }
      function applyTrustBalances() {
        if (!_trustBalances) return;
        $scope.invoices.forEach(i => {
          if (i.client?.billing?.billClient || !i.matter) {
            i.trustBalance = _trustBalances[i.client.id];
          } else if (i.matter) {
            i.trustBalance = _trustBalances[i.matter.id];
          }
        });
      }
      $scope.adjustTotal = (prop, nestedProp) => {
        if (!$scope.invoices) return 0;
        var filteredData = $filter('invoiceFilter')($scope.invoices, $scope.filter);
        filteredData = $filter('filter')(filteredData, $scope.query);
        if (!filteredData) return 0;
        return filteredData.reduce((sum, item) => {
          let value = nestedProp ? item[prop][nestedProp] : item[prop];
          return sum + (value || 0);
        }, 0);
      };
      async function fetchSplitBillingPreview(invoiceId) {
        try {
          const response = await axios.get(`${$scope.domain}/invoices/${invoiceId}/split-recall-preview`);
          return response.data.associatedInvoices || [];
        } catch (error) {
          alerts.error(error);
          return null; // Return null to indicate fallback needed
        }
      }
      function buildSplitBillingConfirmationMessage(associatedInvoices, selectedInvoices) {
        const isPreviewAvailable = associatedInvoices !== null;
        const invoicesToShow = isPreviewAvailable ? associatedInvoices : selectedInvoices;
        const count = invoicesToShow.length;
        const listHeader = `The following ${count} invoice(s) will be removed from QuickBooks and moved back to the draft folder:<br>`;
        const invoiceList = invoicesToShow.map((invoice, index) => `${index + 1}. Invoice ${invoice.reference || 'No Reference'}`).join('<br>');
        return listHeader + invoiceList;
      }
      async function showSplitBillingRecallConfirmation(invoices, option, splitBillingCount = 1, isMixedSelection = false) {
        $scope.help = null;
        alerts.dismiss();
        if (!invoices.length) {
          $scope.help = 'Pick one or more invoices first';
          return $q.reject();
        }
        const d = $q.defer();
        let confirmationMessage;

        // If multiple split billing invoices, show generic message without API call
        if (splitBillingCount > 1 || isMixedSelection) {
          let warningMessage;
          if (isMixedSelection) {
            warningMessage = `Note: The selection contains ${splitBillingCount} split billing invoice(s) and ${invoices.length - splitBillingCount} regular invoice(s). Some additional associated split invoices may also be reverted.<br>`;
          } else {
            warningMessage = `Note: ${splitBillingCount} split billing invoices selected. Some additional associated split invoices may also be reverted.<br>`;
          }
          const confirmMessage = 'Proceed with recall?';
          confirmationMessage = warningMessage + confirmMessage;
        } else {
          // Single split billing invoice, use existing logic with API call
          try {
            const firstInvoice = invoices[0];
            const associatedInvoices = await fetchSplitBillingPreview(firstInvoice.id);
            confirmationMessage = buildSplitBillingConfirmationMessage(associatedInvoices, invoices);
          } catch (error) {
            d.reject(error);
            return d.promise;
          }
        }
        bootbox.confirm({
          title: 'Recall Split Billing Invoices',
          message: confirmationMessage,
          buttons: {
            confirm: {
              label: 'Ok',
              className: 'btn-primary'
            },
            cancel: {
              label: 'Cancel',
              className: 'btn-default'
            }
          },
          callback: function (result) {
            if (result) {
              // Mark this option as already confirmed to skip the standard confirmation
              option.alreadyConfirmed = true;
              d.resolve(invoices);
            } else {
              d.reject();
            }
          }
        });
        return d.promise;
      }
      function confirmAction(invoices, option) {
        $scope.help = null;
        alerts.dismiss();
        if (!invoices.length) {
          $scope.help = 'Pick one or more invoices first';
          return $q.reject();
        }

        // Skip confirmation if it has already been handled (e.g., for split billing)
        if (option.alreadyConfirmed) {
          return $q.resolve(invoices);
        }
        if (!option.prompt) {
          return $q.resolve(invoices);
        }
        const prompt = option.prompt.replace('##', processService.pluralize(invoices.length, ' invoice'));
        const d = $q.defer();
        bootbox.confirm(prompt, ok => {
          if (!ok) return d.reject();
          d.resolve(invoices);
        });
        return d.promise;
      }
      function getSelectedInvoices() {
        const sorted = $filter('orderBy')($scope.invoices, $scope.sort, $scope.reverse);
        return _.filter(sorted, i => i.selected);
      }
      function downloadInvoices(bulk) {
        printInvoices(true, bulk);
      }
      function showAllocation(invoice) {
        clearModalHack();
        return ModalService.showModal({
          template: require('../../modals/allocation/template.html'),
          inputs: {
            params: {
              invoice
            }
          },
          bodyClass: 'show-modal-overlay',
          controller: 'AllocationModalController'
        }).then(modal => {
          modal.element.modal();
          modal.close.then(() => {
            // Remove modal-open class from body which breaks print
            $('body').removeClass('modal-open');
          });
        });
      }
      function viewInvoiceSummary(invoice) {
        trackInvoiceAction('Click', 'View Invoice Summary', invoice);
        $state.go(`billing.review.${$scope.invoiceState}.invoiceSummary`, {
          id: invoice.id
        });
      }
      function printInvoices(zip, bulk) {
        $scope.help = null;
        alerts.dismiss();
        $scope.invoicesToPrint = getSelectedInvoices();
        if ($scope.invoicesToPrint.length === 0) {
          $scope.help = 'Pick one or more invoices first';
          return;
        }
        const sorted = $filter('orderBy')($scope.invoicesToPrint, $scope.sort, $scope.reverse);
        const ids = _.map(sorted, i => i.id).join(',');
        let link = `/v1/invoices/pdf?download=true&bulk=${bulk}&timeOffset=${$scope.timeOffset}`;
        $scope.help = 'Invoices will be generated as PDF  and downloaded in your browser. It might take some time if you have selected a lot of invoices.';
        if (zip) {
          $scope.help = 'Invoices will be generated as a ZIP file of PDFs and downloaded in your browser. It might take some time if you have selected a lot of invoices.';
          link += '&zip=true';
        }
        if (sorted.find(x => x.attachments.trustStatement)) {
          link += '&includeAttachments=true';
        }
        download.post(link, {
          invoices: ids
        });
        return;
      }
      function requiresQboConnection(actions) {
        return !!(actions.submit || actions.send || actions.emailCustomization || actions.pay || actions.trust || actions.groupInvoiceEmail);
      }
      function processInvoice(option, invoice) {
        const zeroRateConfirmationMessage = 'Note: One or more of the entries in this draft invoice have a $0 rate defined. ' + 'If you continue, this will result in time entries with $0 rates.';
        if (option.disabled) return;
        const actions = option?.actions || {};
        const features = $scope.me.features;

        // Block restricted actions for orphan billed invoices
        if (invoice && invoice.isOrphanBilled && requiresQboConnection(actions)) {
          alerts.error('This invoice is no longer linked to QuickBooks. ' + 'It may have been deleted in QuickBooks or the connection was changed. ' + 'This action is not available for unlinked invoices.');
          return;
        }
        if (actions.emailCustomization && features.emailCustomization) {
          openCustomizationEmailModal(invoice, option);
          return;
        }
        if (actions.groupInvoiceEmail && features.multiInvoiceDelivery) {
          openClientAddressModal(option);
          return;
        }
        if (actions.groupInvoicePdf && features.multiInvoiceDelivery) {
          openClientAddressModal(option);
          return;
        }
        if (invoice) {
          if (invoice.hasZeroRateEntries && option.actions.submit) {
            bootbox.confirm(zeroRateConfirmationMessage, result => {
              if (result) {
                processSelectedInvoices([invoice], option);
              }
            });
          } else {
            // Handle split billing recall for single invoice
            if (option.actions.recall && invoice.isSplitBilling) {
              trackInvoiceAction('Click', 'Back to Draft', invoice);
              showSplitBillingRecallConfirmation([invoice], option, 1, false).then(() => processSelectedInvoices([invoice], option)).catch(() => {});
              return;
            }
            processSelectedInvoices([invoice], option);
          }
          if (option.actions.recall) {
            trackInvoiceAction('Click', 'Back to Draft', invoice);
          }
          if (option.actions.pay) {
            if (option.actions.trust) {
              trackInvoiceAction('Click', 'Pay from Trust', invoice);
            } else {
              trackInvoiceAction('Click', 'Record payment', invoice);
            }
          }
          if (option.actions.statement) {
            trackInvoiceAction('Click', 'Attach Trust Statement', invoice);
          }
        } else {
          const invoices = getSelectedInvoices();

          // Block restricted bulk actions if any selected invoice is orphan billed
          if (requiresQboConnection(actions) && invoices.some(i => i.isOrphanBilled)) {
            alerts.error('One or more selected invoices are no longer linked to QuickBooks. ' + 'Please deselect unlinked invoices before performing this action.');
            return;
          }
          const anyZeroRate = invoices.some(invoice => invoice.hasZeroRateEntries);

          // Check if any selected invoices are split billing
          const anySplitBilling = invoices.some(invoice => invoice.isSplitBilling);

          // Count how many split billing invoices are selected
          const splitBillingCount = invoices.filter(invoice => invoice.isSplitBilling).length;

          // Check if this is a mixed selection (split billing + non-split billing)
          const isMixedSelection = splitBillingCount > 0 && splitBillingCount < invoices.length;
          if (option.actions.recall && anySplitBilling) {
            showSplitBillingRecallConfirmation(invoices, option, splitBillingCount, isMixedSelection).then(() => processSelectedInvoices(invoices, option)).catch(() => {});
            return;
          }
          if (anyZeroRate && option.actions.submit) {
            bootbox.confirm(zeroRateConfirmationMessage, result => {
              if (result) {
                processSelectedInvoices(invoices, option);
              }
            });
          } else {
            processSelectedInvoices(invoices, option);
          }
        }
      }
      function processSelectedInvoices(invoices, option) {
        if (invoices.length > 1) {
          option.bulk = true;
        }
        processByOption(invoices, option).then(result => {
          if (!result) return;
          // DeliveryStatus 6 is EmailFailed enum value
          const success = invoices.filter(i => i.process && i.process.done && i.deliveryStatus !== 6).length;
          const error = invoices.filter(i => i.process && (i.process.error || i.deliveryStatus === 6)).length;
          const isEmailAction = option.actions.emailCustomization || option.actions.send || option.actions.groupInvoiceEmail;
          if (!success) {
            alerts.error(`Failed to process ${processService.pluralize(error, 'invoice')} - see more detail by hovering on the warning icon in the list above`);
          } else if (!error) {
            // Check if this is a split billing recall to show custom success message
            const isSplitBillingRecall = option.actions.recall && invoices.some(inv => inv.isSplitBilling);
            if (isSplitBillingRecall) {
              const recalledCount = invoices.filter(i => i.process && i.process.done).length;
              if (recalledCount > 0) {
                const message = recalledCount === 1 ? 'Split billing invoice and all associated invoices were successfully recalled to drafts' : `${recalledCount} split billing invoices and all associated invoices were successfully recalled to drafts`;
                alerts.success(message);
              }
            } else if (isEmailAction) {
              alerts.success(`Processing ${processService.pluralize(success, 'invoice')}`);
            } else {
              // Show generic success message for non-email operations
              alerts.success(`Successfully processed ${processService.pluralize(success, 'invoice')}`);
            }
          } else {
            if (isEmailAction) {
              alerts.warning(`Processed ${processService.pluralize(success, 'invoice')}. Check the Delivery status for failed deliveries`);
            } else {
              alerts.error(`Successfully processed ${processService.pluralize(success, ' invoice')}, but
                  ${processService.pluralize(error, 'invoice')} failed! See more detail by hovering on the warning icon in the list above`);
            }
          }
          return reloadProcessedInvoices(invoices, success, option);
        }).finally(() => {
          // Reset the alreadyConfirmed flag to prevent it from affecting future operations
          if (option.alreadyConfirmed) {
            option.alreadyConfirmed = false;
          }
          $scope.processing = false;
        });
      }
      function reloadProcessedInvoices(invoices, success, option) {
        if (!success) {
          // no reason to reload if there are no errors
        } else if (option.actions.submit || option.actions.recall || option.actions.undo) {
          // For split billing recall, we need to reload the entire list since 
          // associated invoices may not be in the current view
          const isSplitBillingRecall = option.actions.recall && invoices.some(inv => inv.isSplitBilling);
          if (isSplitBillingRecall) {
            // Reload the entire invoice list to show updated state
            reload();
          } else {
            // Standard behavior for non-split billing recalls
            $scope.invoices = $scope.invoices.filter(i => !i.process || !i.process.done);
          }
        } else if (success < 5 && $scope.invoices.length > 10) {
          // reload individual invoices
          // TODO (for now just reload all)
          reload($scope.invoices);
        } else {
          // reload all invoices
          reload($scope.invoices);
        }
        if (option.actions.trust) {
          // We are paying with trust, reload trust balances
          reloadTrust();
        }
        if (option.actions.pay) {
          // TODO reload AR
        }
      }
      function processByOption(invoices, option) {
        const bulk = invoices.length > 1;
        if (option.actions.pay) {
          if (option.actions.trust) {
            return confirmAndProcessTrust(invoices);
          }
          return confirmAndProcessPayment(invoices);
        }
        return confirmAction(invoices, option).then(invoices => {
          $scope.processing = true;
          if (option.actions.attachments && option.actions.ledes) {
            return processAttachmentsPlusLedes(invoices, option.actions.combine);
          }
          if (option.actions.ledes) {
            return processLedes(invoices, option.actions.combine);
          }
          if (option.actions.download) {
            return downloadInvoices(bulk);
          }
          if (option.actions.print) {
            return printInvoices(false, bulk);
          }
          if (option.actions.bulkInvoiceDateChange) {
            handleBulkInvoiceDateChange();
            return;
          }
          return processService.processApi(invoices, option);
        });
      }
      function confirmAndProcessTrust(invoices) {
        clearModalHack();
        const payment = {
          date: new Date()
        };
        const groups = processService.groupInvoices(invoices);
        if (Object.keys(groups).length === 1) {
          const trust = invoices[0].trustBalance;
          const total = invoices.reduce((sum, i) => sum + i.state.balance, 0);
          payment.amount = Math.min(trust, total);
        }
        return new Promise((resolve, reject) => {
          ModalService.showModal({
            template: require('../../modals/trustPayment/template.html'),
            inputs: {
              payment,
              invoices
            },
            bodyClass: 'show-modal-overlay',
            controller: 'TrustPaymentModalController'
          }).then(modal => {
            modal.element.modal();
            return modal.close.then(payment => {
              if (!payment) return reject();
              $scope.processing = true;
              if (Object.keys(groups).length === 1) {
                if (!payment.amount) {
                  return reject();
                }
                // paying one client with potentially an adjusted amount
                const group = groups[Object.keys(groups)[0]];
                return resolve(processService.processPayment(group, {
                  amount: payment.amount,
                  date: payment.date,
                  trust: true
                }));
              }
              // paying multiple trust accounts/clients
              resolve(processPayments(invoices, true, payment.date));
            });
          }, e => {
            console.error('modal rejected:', e);
            reject(e);
          });
        });
      }
      function confirmAndProcessPayment(invoices) {
        clearModalHack();

        // Verify that invoices are "compatible" (same client/matter) so that we can create just one payment for them
        const groups = processService.groupInvoices(invoices);
        if (Object.keys(groups).length !== 1) {
          alerts.error(`You can only pay multiple invoices if they are for the same client (if client-billed) or the same ${$scope.me.terms.matter}`);
          return $q.reject();
        }
        const group = groups[Object.keys(groups)[0]];
        return new Promise((resolve, reject) => {
          ModalService.showModal({
            template: require('../../modals/payment/template.html'),
            inputs: {
              payment: {
                date: new Date(),
                amount: parseFloat(invoices.reduce((sum, i) => sum + i.state.balance, 0).toFixed(2)),
                trust: false
              },
              invoices: group.invoices,
              client: group.client
            },
            bodyClass: 'show-modal-overlay',
            controller: 'PaymentModalController'
          }).then(modal => {
            modal.element.modal();
            return modal.close.then(payment => {
              if (!payment) return reject();
              $scope.processing = true;
              resolve(processService.processPayment(group, payment));
            });
          }, e => {
            console.error('modal rejected:', e);
            reject(e);
          });
        });
      }
      function parseBlobError(result) {
        const genericMessage = 'Unable to download the LEDES file. Please try again or contact support.';
        if (!result || !(result.data instanceof Blob)) {
          return $q.resolve(genericMessage);
        }
        return $q(resolve => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const parsed = JSON.parse(reader.result);
              resolve(parsed.message || genericMessage);
            } catch (e) {
              resolve(genericMessage);
            }
          };
          reader.onerror = () => resolve(genericMessage);
          reader.readAsText(result.data);
        });
      }
      function triggerBlobDownload(data, headers, fallbackName) {
        const contentType = headers && headers('content-type') || 'application/octet-stream';
        const disposition = headers && headers('content-disposition');
        let filename = fallbackName;
        if (disposition) {
          const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i);
          if (match) {
            try {
              filename = decodeURIComponent(match[1]);
            } catch (e) {
              filename = match[1];
            }
            filename = filename.replace(/[\\/:*?"<>|]+/g, '_');
          }
        }
        const blob = new Blob([data], {
          type: contentType
        });
        const objectUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = objectUrl;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      }
      function processLedes(invoices, combine, expenses) {
        const bulk = invoices.length > 1;
        const ids = invoices.map(i => i.id);
        const isSplitBillingIncluded = invoices.some(invoice => invoice.isSplitBilling);
        if (isSplitBillingIncluded && !$scope.me?.features?.leedesSplitFf) {
          alerts.error('LEDES is not supported for split billing invoices');
          return $q.reject();
        }
        if (ids.length === 1) {
          return $http.get(`${leanLawAuth.domain}/v1/invoices/${ids[0]}/ledes?download=true&bulk=${bulk}&timeOffset=${$scope.timeOffset}&expenses=${expenses || false}`, {
            responseType: 'blob'
          }).then(result => {
            triggerBlobDownload(result.data, result.headers, `Invoice-${ids[0]}-ledes`);
            alerts.success("The LEDES file will be downloaded to your browser's download folder.");
            return false;
          }).catch(error => {
            return parseBlobError(error).then(message => {
              alerts.error(message);
              return $q.reject();
            });
          });
        }
        const formData = new FormData();
        formData.append('invoices', ids.join(','));
        return $http.post(`${leanLawAuth.domain}/v1/invoices/ledes?combine=${combine || false}&timeOffset=${$scope.timeOffset}`, formData, {
          responseType: 'blob',
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined
          }
        }).then(result => {
          triggerBlobDownload(result.data, result.headers, combine ? 'Invoices-ledes' : 'Invoices-ledes.zip');
          $scope.help = `The LEDES file(s) will be downloaded${combine ? ' ' : ' as a zip file '}to your browser's download folder.`;
          if (invoices.length > 5) {
            $scope.help += ' It might take some time if you have lots of invoices.';
          }
          return false;
        }).catch(error => {
          return parseBlobError(error).then(message => {
            alerts.error(message);
            return $q.reject();
          });
        });
      }
      function processAttachmentsPlusLedes(invoices, combine) {
        let invoice = invoices[0];
        $http.get(`${leanLawAuth.domain}/v1/expenses/zip?timesheetId=${invoice.id}&invoiceNumber=${invoice.reference}`, {
          responseType: 'blob'
        }).then(result => {
          if (result.status === 200) {
            var cleanInvoiceNumber = invoice.reference.replace(/[<>:"/|?*\\]/g, '');
            triggerBlobDownload(result.data, result.headers, `Invoice-${cleanInvoiceNumber}-expenses`);
            alerts.success("The attachments zip file will be downloaded to your browser's download folder.");
            $q.resolve(false);
            return processLedes(invoices, combine, true);
          } else {
            alerts.error('Unable to download attachments. Please contact support');
          }
        });
      }
      function processPayments(invoices, trust, date) {
        let process = $q.resolve();
        const groups = processService.groupInvoices(invoices, trust);
        Object.keys(groups).forEach(id => {
          process = process.then(_ => {
            const group = groups[id];
            const totalBalance = group.invoices.reduce((sum, i) => sum + i.state.balance, 0);
            return processService.processPayment(group, {
              amount: trust ? Math.min(totalBalance, group.trustBalance) : totalBalance,
              date: date || new Date(),
              trust
            });
          });
        });
        return process.then(() => {
          loadTrust();
          return true;
        });
      }
      function reload(invoicesWithStatus) {
        _loadedState = null;
        _previousRequest = null;
        filterUpdated(invoicesWithStatus);
      }
      function openInvoice(invoice) {
        trackInvoiceAction('Click', 'Open in QuickBooks', invoice);
        $window.open(invoice.accounting.href);
      }
      function getPaymentLink(invoice) {
        tracking.event('Payments', 'Payment Link Copied', {
          invoiceId: invoice.id,
          accountId: $scope.me?.id
        });
        if (invoice.paymentLinkUrl) {
          copyPaymentLink(invoice);
        } else {
          $http.post(`${$scope.domain}/paymentlinks?invoiceId=${invoice.id}`).then(response => {
            if (response.status === 200 && response.data) {
              invoice.paymentLinkUrl = response.data;
              copyPaymentLink(invoice);
            } else {
              let error = `${response?.data?.message || 'Unable to generate payment link'}: ${response?.data?.detail || 'Please contact support'}`;
              alerts.error(error);
            }
          });
        }
      }
      function gravityEnabled() {
        return $scope.me.company?.settings?.gravity?.enabled === true;
      }
      function copyPaymentLink(invoice) {
        $window.focus();
        $window.navigator.clipboard.writeText(invoice.paymentLinkUrl);
        alerts.success(`Payment link for Invoice ${invoice.reference} copied to clipboard`);
      }
      function printInvoice(invoice, markPrinted) {
        let url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf?timeOffset=${$scope.timeOffset}`;
        if (invoice.attachments.trustStatement) {
          url = `${url}&includeAttachments=true`;
        }
        if (markPrinted) {
          // `download=true` makes the backend mark this invoice printed and sync
          // PrintComplete to QuickBooks (same as the "Combined PDF (Print)" flow); it
          // also serves the PDF as a file download rather than opening inline, which is
          // what distinguishes Print from "View Invoice". Only the explicit Print action
          // passes this; plain "View Invoice" opens the PDF inline without marking it.
          url = `${url}&download=true`;
          // The backend only marks processed (QuickBooks) invoices as printed, so
          // optimistically reflect the new delivery status without a full reload.
          if (invoice.processed) {
            invoice.deliveryStatus = 4; // Printed
            invoice.invoiceState = reviewService.invoiceLabel(invoice);
            invoice.invoiceColor = reviewService.invoiceColor(invoice);
          }
        }
        $window.open(url);
      }
      function downloadServicesAndExpenses(invoice) {
        trackInvoiceAction('Click', 'Services & Expenses Summary', invoice);
        let url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/service-expense-pdf`;
        $window.open(url);
      }
      let currentIndex = -1;
      let nextInvoiceId = null; // Add this variable to track the next invoice by ID

      function selectInvoice(invoice, draft) {
        // Get the current view of invoices that matches what the user sees
        const visibleInvoices = $scope.filtered;
        if (!invoice) {
          // Case 1: Auto-advancing to next invoice
          if (nextInvoiceId) {
            // Try to find the invoice we previously marked as "next"
            invoice = visibleInvoices.find(inv => inv.id === nextInvoiceId);
            nextInvoiceId = null; // Clear the stored ID since we're using it now
          }

          // If we don't have a specific next invoice ID or couldn't find it,
          // fall back to using currentIndex
          if (!invoice) {
            if (currentIndex >= 0 && currentIndex < visibleInvoices.length - 1) {
              invoice = visibleInvoices[currentIndex + 1];
            } else {
              alerts.info('You have reached the final invoice. Auto-advance is not available.');
              return;
            }
          }
        }

        // Find position of this invoice in the current view
        var idx = visibleInvoices.findIndex(inv => inv.id === invoice.id);
        currentIndex = idx;

        // Store the ID of the invoice that should be "next" for future auto-advance
        if (currentIndex >= 0 && currentIndex < visibleInvoices.length - 1) {
          nextInvoiceId = visibleInvoices[currentIndex + 1].id;
        } else {
          nextInvoiceId = null;
        }
        if (invoice.processed && !draft) {
          trackInvoiceAction('Click', 'View Invoice', invoice);
          return printInvoice(invoice);
        }

        // Track draft invoice opened event
        const trackingData = {
          invoiceId: invoice.id,
          invoiceState: $scope.invoiceState,
          sourceContext: $scope.me.company.settings && $scope.me.company.settings.demoMode ? 'trainingFlow' : 'regularUsage'
        };
        tracking.event('Draft Invoice', 'Opened', trackingData);
        $state.go(`billing.review.${$scope.invoiceState}.edit`, {
          invoiceId: invoice.id
        });
      }
      function exportExcel() {
        const matter = $scope.me.terms.Matter;
        const State = $scope.invoiceState === 'quickbooks' ? 'Delivery' : 'State';
        const items = $scope.invoices.map(i => {
          const item = {
            Number: i.reference || '-',
            Date: new Date(i.invoiceDate).toShortDateString(),
            'Client ID': i.client.reference,
            Client: i.client.name,
            [`${matter} ID`]: i.matter && i.matter.reference,
            [matter]: i.matter && i.matter.name,
            Responsible: i.matter && i.matter.primary && i.matter.primary.name
          };
          if (i.matters.length) {
            item[`${matter} ID`] = i.matters.map(m => m.reference).join(', ');
            item[matter] = i.matters.map(m => m.name).join(', ');
            item.Responsible = i.matters.map(m => m.primary && m.primary.name).join(', ');
          }
          if (!$scope.showBalance) {
            item.Fees = $filter('currency')(i.totals.services);
            item.Expenses = $filter('currency')(i.totals.expenses);
            item.Total = $filter('currency')(i.totals.amount);
          }
          if ($scope.showBalance) {
            item.Billed = $filter('currency')(i.totals.billedAmount);
            item.Balance = $filter('currency')(i.state.balance);
          }
          if ($scope.showTrust) {
            item.Trust = $filter('currency')(i.trustBalance);
          }
          if ($scope.showEvergreen) {
            item.Replenish = $filter('currency')(i.replenish);
          }
          if ($scope.showStatus) {
            item[State] = i.invoiceState;
          }
          if ($scope.showDue) {
            item.Due = i.state.closed ? 'Paid' : new Date(i.due).toShortDateString();
          }
          return item;
        });
        exportJson.downloadCsv(items, `${$scope.invoiceState}`);
      }
      function openCustomizationEmailModal(invoice, option) {
        // Block email for orphan billed invoices
        if (invoice && invoice.isOrphanBilled) {
          alerts.error('This invoice is no longer linked to QuickBooks. ' + 'It may have been deleted in QuickBooks or the connection was changed. ' + 'Email is not available for unlinked invoices.');
          return;
        }
        if (!invoice) {
          const invoices = getSelectedInvoices();
          // Block bulk email if any selected invoice is orphan billed
          if (invoices.some(i => i.isOrphanBilled)) {
            alerts.error('One or more selected invoices are no longer linked to QuickBooks. ' + 'Please deselect unlinked invoices before sending email.');
            return;
          }
          $state.go(`billing.review.${$scope.invoiceState}.emailCustomization`, {
            option,
            invoices
          });
          return;
        }
        $state.go(`billing.review.${$scope.invoiceState}.emailCustomization`, {
          id: invoice.id,
          invoice,
          option
        });
      }
      function openClientAddressModal(option) {
        const invoices = getSelectedInvoices();
        if (!invoices) return;
        const clientId = invoices[0].client.id;
        $state.go(`billing.review.${$scope.invoiceState}.clientBillingAddress`, {
          id: clientId,
          option,
          invoices,
          invoiceState: $scope.invoiceState
        });
      }
      function processGroupInvoicePdf(pdfBody = {}) {
        const invoices = getSelectedInvoices();
        const invoiceIds = invoices.map(i => i.id);
        pdfBody.invoiceIds = invoiceIds;
        if (invoiceIds.length > 50) {
          alerts.error('Too many invoices selected. Please select 50 or fewer invoices.');
          return;
        }
        $http.post(`${$scope.domain}/customemail/print-with-clientinfo`, pdfBody).then(res => {
          if (res.status === 200) {
            invoices.forEach(i => {
              i.process = {
                done: true
              };
              i.selected = false;
            });
            trackGroupAction('GroupInvoice', invoiceIds);
            alerts.success('Your multi-invoice document is being generated and will be emailed to you shortly. You can continue working while we process your request.');
          } else {
            alerts.error('There was an issue processing your request. Please try again later.');
          }
        }).catch(e => {
          alerts.error(e);
        });
      }
      function sendGroupInvoiceEmail(emailBody) {
        const invoices = getSelectedInvoices();
        const invoiceIds = invoices.map(i => i.id);
        emailBody.invoiceIds = invoiceIds;
        $http.post(`${$scope.domain}/customemail`, emailBody).then(res => {
          if (res.status === 200) {
            invoices.forEach(i => {
              i.process = {
                done: true
              };
              i.selected = false;
            });
            trackGroupAction('GroupEmail', invoiceIds);
          } else {
            alerts.error('There was an issue processing your request. Please try again later.');
          }
        }).catch(e => {
          alerts.error(e);
        });
      }
      function goToTrackSentEmail(invoice) {
        $http.get(`${$scope.domain}/emaillogs/invoices/${invoice.id}`).then(res => {
          $state.go(`billing.invoiceEmailActivity`, {
            emailLogId: res.data.emailLogId
          });
        }).catch(err => {
          alerts.error(err);
        });
      }
      function processCustomizedEmail(invoice, option, emailBody) {
        option.emailBody = emailBody;
        if (invoice) {
          processSelectedInvoices([invoice], option);
        } else {
          const invoices = getSelectedInvoices();
          processSelectedInvoices(invoices, option);
        }
      }
      function trackInvoiceAction(action, label, invoice) {
        const {
          totals: {
            billedAmount
          }
        } = invoice;
        $scope.traceData.amount = billedAmount;
        tracking.event(action, label, $scope.traceData);
      }
      function trackGroupAction(method, invoiceIds) {
        const data = {
          bulk: true,
          companyName: $scope.me.company.name,
          email: $scope.me.email,
          method,
          invoiceIds: invoiceIds.join(',')
        };
        tracking.event('Invoice', 'Delivered', data);
      }
      $scope.updateInvoiceCheck = function () {
        if (!$scope.me.features.multiInvoiceDelivery) return;
        const selectedInvoices = $scope.invoices.filter(i => i.selected);
        $scope.enableMultipleInvoiceOption = selectedInvoices.length > 1 && selectedInvoices.every(i => i.client.id === selectedInvoices[0].client.id);
        $scope.hasOrphanBilledSelected = selectedInvoices.some(i => i.isOrphanBilled);
        disableDeliverEmailOptions();
      };
      function disableDeliverEmailOptions() {
        const deliverOption = $scope.options.find(o => o.id === 'deliver');
        if (deliverOption) {
          deliverOption.dropdown.forEach(d => {
            if (d.isMultiInvoiceOption) {
              d.disabled = !$scope.enableMultipleInvoiceOption;
            }
            // Disable "Email Invoices Individually" when any selected invoice is orphan billed
            if (d.actions && d.actions.emailCustomization && !d.isMultiInvoiceOption) {
              d.disabled = !!$scope.hasOrphanBilledSelected;
            }
          });
        }
      }
      function handleBulkInvoiceDateChange() {
        if (!$scope.bulkDate) {
          alerts.error('Please select a valid date.');
          return;
        }
        var selectedInvoices = getSelectedInvoices();
        if (!selectedInvoices.length) {
          alerts.error('Please select one or more invoices first.');
          return;
        }
        var invoiceIds = selectedInvoices.map(function (invoice) {
          return invoice.id;
        });
        var confirmMsg = 'Apply the new date ' + new Date($scope.bulkDate).toLocaleDateString() + ' to ' + selectedInvoices.length + ' invoice(s)?';
        bootbox.confirm(confirmMsg, function (result) {
          if (result) {
            $http.put(`${$scope.domain}/invoices/bulk-date-update`, {
              invoiceIds: invoiceIds,
              updatedDate: $scope.bulkDate
            }).then(function (response) {
              alerts.success('Bulk date change applied successfully.');
              reload();
            }).catch(function (error) {
              alerts.error('Error updating dates: ' + (error.data.message || error.statusText));
            });
          }
        });
      }
    }
  }
})();